import store from '../store'
function makeHeader() {
    let headers = { 'Content-Type': 'application/json' };
    if(process.env.VUE_APP_FAKEAUTH){
        headers['FakeAuth'] =  process.env.VUE_APP_FAKEAUTH;
    } else {
        headers['Authorization'] = `Bearer ${store.state.gToken}`;
    }
    if(store.state.userid) {
        headers['X-Hasura-User-Id'] = store.state.userid;
    }
    return headers
}

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
}

export default{
    queryGQL: async function (gql){
        if(!store.state.userid) {
            throw new Error("ログインが確認できません");
        }
        gql = gql.trim()
        console.assert(gql.startsWith('{') && gql.endsWith('}'), "GQL should be {}\n" + gql);
        let res = await fetch('/v1/graphql', {
            method: 'POST',
            headers: makeHeader(),
            body: JSON.stringify({ "query": gql })
        });
        if(!res.ok){ 
            console.log(gql);
            throw new Error(await res.json());
        }
        let ret = await res.json();
        if(ret['errors']){
            console.log("ERROR ON GQL\n" + gql);
            throw new Error(`GraphQL ERROR ${JSON.stringify(ret['errors'])}`);
        } else {
            return ret['data'];
        }
    },
    get: async function(url){
        try {
            let res = await fetch(url, {
                method: 'GET',
                headers: makeHeader()
            });
            console.log(res);
            if(!res.ok){ throw new Error('通信エラー\n' + await res.statusText); }
            return await res.json();
        } catch(Err) {
            console.log(Err);
            throw Err;
        }
    },
    post: async function(path, data){
        try {
            let res = await fetch(path, {
                method: 'POST',
                headers: makeHeader(),
                body: JSON.stringify(data) });
            if(!res.ok){ throw new Error('通信エラー\n' + res.stateusText); }
            return await res.json();
        } catch(Err) {
            console.log(Err);
            throw Err;
        }
    },
    put: async function(path, data){
        try {
            let res = await fetch(path, {
                method: 'PUT',
                headers: makeHeader(),
                body: JSON.stringify(data) });
            if(!res.ok){ throw new Error('通信エラー\n' + res.stateusText); }
            return await res.json();
        } catch(Err) {
            console.log(Err);
            throw Err;
        }
    },
    delete: async function(path, data){
        try {
            let res = await fetch(path, {
                method: 'DELETE',
                headers: makeHeader(),
                body: JSON.stringify(data) });
            if(!res.ok){ throw new Error('通信エラー\n' + res.stateusText); }
            return await res.json();
        } catch(Err) {
            console.log(Err);
            throw Err;
        }
    },
    isTokenExpired: function() {
        let info = parseJwt(store.state.gToken);
        console.log(`expires ${new Date(info.exp*1000)}`);
        return new Date(info.exp*1000) < (new Date())
    }

}

